import React from 'react';
import { RefreshCcw } from 'lucide-react';

/** Editable entity reference (رمز) field for pointage modals. */
export default function PointageEntityReferenceField({
  value,
  onChange,
  onRegenerate,
  label,
  placeholder,
  autoGeneratedHint,
  regenerateTitle,
  inputClassName = '',
  labelClassName = '',
  required = true,
  readOnly = false,
}) {
  return (
    <div className="min-w-0">
      <label className={labelClassName}>
        {label}
        {!readOnly && autoGeneratedHint ? (
          <span className="text-white/40 text-xs ms-2 font-normal">{autoGeneratedHint}</span>
        ) : null}
      </label>
      <div className="flex items-center gap-2">
        <input
          type="text"
          required={required}
          readOnly={readOnly}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className={`${inputClassName} font-mono flex-1`}
          placeholder={placeholder}
          dir="ltr"
          autoComplete="off"
          spellCheck={false}
        />
        {!readOnly && onRegenerate ? (
          <button
            type="button"
            onClick={onRegenerate}
            className="shrink-0 p-2.5 rounded-xl border border-white/20 bg-white/5 text-white/70 hover:bg-white/10 hover:text-white transition-colors"
            title={regenerateTitle}
            aria-label={regenerateTitle}
          >
            <RefreshCcw size={16} />
          </button>
        ) : null}
      </div>
    </div>
  );
}
